export default __webpack_public_path__ + "static/thinkster-14c3b220ec00cdf59f0d6a7bf2ce3727.svg";